import { Breadcrumbs } from "./Breadcrumbs";
import { ContextNav } from "./ContextNav";
import { Container, Eyebrow } from "./primitives";

export const PageIntro = ({ routeKey, via, group, index, eyebrow, title, lede, aside, children }) => (
  <header className="relative overflow-hidden border-b border-o-line" data-testid={`intro-${routeKey}`}>
    <div aria-hidden className="blueprint blueprint-fade pointer-events-none absolute inset-0 opacity-60" />
    <Container className="relative">
      <div className="pt-8">
        <Breadcrumbs routeKey={routeKey} via={via} />
      </div>
      {group && (
        <div className="mt-5">
          <ContextNav group={group} current={routeKey} />
        </div>
      )}
      <div className="grid gap-12 py-14 lg:grid-cols-12 lg:gap-10 lg:py-20">
        <div className="fade-up lg:col-span-7">
          <Eyebrow index={index}>{eyebrow}</Eyebrow>
          <h1 data-testid="page-title" className="mt-6 font-display text-4xl font-extrabold leading-[1.02] tracking-[-0.015em] sm:text-5xl lg:text-6xl">
            {title}
          </h1>
          {lede && <p className="mt-6 max-w-2xl text-base leading-relaxed text-o-dim sm:text-lg">{lede}</p>}
          {children}
        </div>
        {aside && <div className="fade-up delay-2 lg:col-span-5">{aside}</div>}
      </div>
    </Container>
  </header>
);
